/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Input, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { FreemodeCarouselItem } from 'src/app/models/freecarouselItem';

@Component({
  selector: 'freemode-carousel',
  templateUrl: './freemode-carousel.component.html',
  styleUrls: ['./freemode-carousel.component.scss'],
})
export class FreemodeCarouselComponent implements OnInit {
  @Input() title: string;
  @Input() list: FreemodeCarouselItem[];
  @Input() baseUrl: string;
  public slideOpts: any;
  constructor() {
    this.slideOpts = {
      spaceBetween: 10,
      freeMode: true,
      passiveListeners: true,
      slidesPerView: 2,
      pagination: {
        // clickable: true
      },
    };
  }
  ngOnInit() {}
}
